import { Vector2 as ThreeVector2, Vector3 as ThreeVector3, Vector4 as ThreeVector4} from "three";
import { Vector2, Vector3, Vector4 } from "@react-three/fiber";

type Vector = Vector2 | Vector3 | Vector4;

export class FiberUtils {
    static extract(vector: Vector2 | undefined, component: "x" | "y"): number;
    static extract(vector: Vector3 | undefined, component: "x" | "y" | "z"): number;
    static extract(vector: Vector4 | undefined, component: "x" | "y" | "z" | "w"): number;
    static extract(vector: Vector | undefined, component: "x" | "y" | "z" | "w") {
        if (vector instanceof ThreeVector2) return vector[component as "x" | "y"];
        if (vector instanceof ThreeVector3) return vector[component as "x" | "y" | "z"];
        if (vector instanceof ThreeVector4) return vector[component as "x" | "y" | "z" | "w"];
        if (typeof vector === "number") return vector;
        if (vector) {
            switch (component) {
                case "x": return vector.length >= 1 ? vector[0] : 0;
                case "y": return vector.length >= 2 ? vector[1] : 0;
                case "z": return vector.length >= 3 ? vector[2] : 0;
                case "w": return vector.length >= 4 ? vector[3] : 0;
            }
        }
        return 0;
    }

    static toVector2(vector: Vector2): ThreeVector2 {
        if (vector instanceof ThreeVector2) return vector;
        if (typeof vector === "number") return new ThreeVector2(vector, vector);
        if (vector) return new ThreeVector2(...vector);
        return new ThreeVector2();
    }
    static toVector3(vector: Vector3): ThreeVector3 {
        if (vector instanceof ThreeVector3) return vector;
        if (typeof vector === "number") return new ThreeVector3(vector, vector, vector);
        if (vector) return new ThreeVector3(...vector);
        return new ThreeVector3();
    }
    static toVector4(vector: Vector4): ThreeVector4 {
        if (vector instanceof ThreeVector4) return vector;
        if (typeof vector === "number") return new ThreeVector4(vector, vector, vector, vector);
        if (vector) return new ThreeVector4(...vector);
        return new ThreeVector4();
    }
}